export const setClient = (state, client) => {
  state.client = client;
};

export const setContacts = (state, { data, totalCount, overwriteContacts }) => {
  if (overwriteContacts || (state.contacts || null) === null) {
    state.contacts = data;
  } else {
    state.contacts = state.contacts.concat(data);
  }

  state.totalClientContactCount = totalCount;
};

export const setPolicyTitle = (state, policyTitle) => {
  state.policyTitle = policyTitle;
};

export const setSelectedLineOfBusinessCode = (state, code) => {
  state.selectedLineOfBusinessCode = code;
};

export const setLobName = (state, name) => {
  state.lobName = name;
};

export const setError = (state, error) => {
  state.error = error;
};

export const clearError = (state) => {
  state.error = undefined;
};

export const setActiveClientTab = (state, val) => {
  state.activeClientTab = val;
};

export const setActivePolicyTab = (state, val) => {
  state.activePolicyTab = val;
};

export const setActiveLineOfBusinessTab = (state, val) => {
  state.activeLineOfBusinessTab = val;
};

export const setActiveVehicleTab = (state, val) => {
  state.activeVehicleTab = val;
};

export const setSelectedProfile = (state, id) => {
  state.selectedProfileId = id;
};
